const _obj = {
  /**
   * Check if value exists in an object.
   * Optional 'sub_key' param to iterate through nested object.
   *
   * Returns the obj key if found or false if not found
   *
   * @param value
   * @param object
   * @param sub_key
   * @returns {boolean}
   */

  hasValue: function (value, object, sub_key = '') {
    let res = false;
    for(let obj in object) {
      const $obj = sub_key.length ? obj[sub_key] : obj;

      if($obj === value) {
        res = obj.toString();
      }
    }

    return res;
  },
}

export default _obj;



// WEBPACK FOOTER //
// ./scripts/util/_obj.js